import React from 'react';
import PropTypes from 'prop-types';

import { FixtureLinkButton } from './FixtureLinkButton';

import { getTranslation } from 'common/react/utils/translations';
import { useGetContentQuery } from 'store/modules/api/content-api';

export const FixtureMatchReportLink = ({ match, reportLabel }) => {
    const requestConfig = {
        type: 'TEXT',
        params: {
            pageSize: 1,
            references: `AFL_MATCH:${match.id}`,
            tagNames: `match-report`
        }
    };

    const { data: matchReport } = useGetContentQuery(requestConfig);

    if (matchReport && matchReport.content.length) {
        return (
            <FixtureLinkButton
                href={PULSE.app.common.url.getMatchURL(match, reportLabel)}
                icon="report"
                label={getTranslation('label.fixtures.match-report')}
                theme="alt"
            />
        );
    }

    return <></>;
};

FixtureMatchReportLink.propTypes = {
    match: PropTypes.object.isRequired,
    reportLabel: PropTypes.string
};
